import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  addOrUpdateTranslationRequest,
  deleteTranslationRequest,
  getAllTranslationsRequest,
} from 'api/requests/translation-requests';
import { ITranslationRow } from 'modules/translations/types';
import {
  TRANSLATIONS__DELETE_ONE,
  TRANSLATIONS__GET_ALL,
  TRANSLATIONS__LOADING,
  TRANSLATIONS__UPDATE_ONE,
} from 'store/constants';

export const translationsLoadingAction = createAction<boolean>(TRANSLATIONS__LOADING);
export const setAllTranslationsAction = createAction<ITranslationRow[]>(TRANSLATIONS__GET_ALL);

export const getAllTranslationsAction = createAsyncThunk(TRANSLATIONS__GET_ALL, async (_, { dispatch }) => {
  dispatch(translationsLoadingAction(true));
  try {
    const response = await getAllTranslationsRequest();
    dispatch(setAllTranslationsAction(response));
  } catch (error) {
    console.log(error);
  }
  dispatch(translationsLoadingAction(false));
});

export const addOrUpdateTranslationAction = createAsyncThunk(
  TRANSLATIONS__UPDATE_ONE,
  async (translation: ITranslationRow, { dispatch }) => {
    dispatch(translationsLoadingAction(true));
    try {
      await addOrUpdateTranslationRequest(translation);
    } catch (error) {
      console.log(error);
    }
    dispatch(translationsLoadingAction(false));
  },
);

export const deleteTranslationAction = createAsyncThunk(
  TRANSLATIONS__DELETE_ONE,
  async (translationKeyId: number, { dispatch }) => {
    dispatch(translationsLoadingAction(true));
    try {
      await deleteTranslationRequest(translationKeyId);
    } catch (error) {
      console.log(error);
    }
    dispatch(translationsLoadingAction(false));
  },
);
